import ko from './translations/ko.json'
import en from './translations/en.json'
import vi from './translations/vi.json'
import ne from './translations/ne.json'
import my from './translations/my.json'
import uz from './translations/uz.json'
import kh from './translations/kh.json'
import lk from './translations/lk.json'
import ph from './translations/ph.json'
import bd from './translations/bd.json'

export default {
  ko,
  en,
  vi,
  ne,
  my,
  uz,
  kh,
  lk,
  ph,
  bd
}
